export const SUBSCRIPTION_ROUTE = "/users/subscriptions"

export const SUBSCRIPTION_ID_KEY = "subscription_id"
export const SUBSCRIPTION_EMAIL_KEY = "subscription_email"

/**
 * Parses the url parameters provided, checking if a subscription ID was provided.
 * @param url URL object or path
 * @returns
 */
export function parseSubscriptionParams(url: URL | string): {
	id: string
	email: string
} | null {
	if (typeof url === "string") {
		url = new URL(url)
	}

	const params = new URLSearchParams(url.search)

	const subscriptionId = params.get(SUBSCRIPTION_ID_KEY)
	const email = params.get(SUBSCRIPTION_EMAIL_KEY)

	if (!(subscriptionId && email)) return null

	return {
		id: subscriptionId,
		email,
	}
}
